import * as azureItems from './azureItems';
import * as mondayItems from './mondayItems';
import * as jiraItems from './jiraItems';
import { HostPlatform, Azure, JIRA, Monday } from '../../config/hostPlatform';

// @ts-ignore
const Platforms = new Map([
  [Azure, azureItems],
  [JIRA, jiraItems],
  [Monday, mondayItems],
]);

const api = Platforms.get(HostPlatform.activeId);

const getItemById = async (itemId) => {
  if (!api) {
    throw new Error('No API found for this platform');
  }
  const [item] = await api.getItemsByIds([itemId]);
  return item;
};

// @ts-ignore
const { getItemsByIds, createItem, openItemDialog, getItemTypes } = api;

export { getItemById, getItemsByIds, createItem, openItemDialog, getItemTypes };
